:host {
  /** @prop --color-background: The background color of the context menu. */
  --color-background: var(--dnn-color-background, white);
  
  /** @prop --color-border: The border color of the context menu. */
  --color-border: var(--dnn-color-foreground, black);
  
  /** @prop --padding: The padding inside the context menu. */
  --padding: 0.25rem;
  
  display: none;
  flex-direction: column;
  position: fixed;
  z-index: 1;
  background-color: var(--color-background);
  border: 1px solid var(--color-border);
  padding: var(--padding);
}

::slotted(*) {
  display: flex;
  width: 100%;
  white-space: nowrap;
}
